<ng-template #addChildButtonTemplate let-idvaluechild="idvalue" let-elementinput="element">
  <div *ngIf="!elementinput['base_fkid']" class="row justify-content-center">
    <button class="btn btn-action" (click)="getNewChildLink(idvaluechild)" title="Add child">
      <i class="far fa-clone"></i>{{elementinput['base_fkid']}}
    </button>
  </div>
</ng-template>

<app-crud-list [observabledata]="observabledata"
               [displayedColumns]="displayedcolumns"
               [postTreatmentCallback]="getPostTreatmentCallback()"
               [idColumnName]="'id'"
               [entityroot]="entityroot"
               [deleteEntityHandler]="deleteEntityHandler()"
               [removePostTreatmentHandler]="deletePostTreatmentHandler()"
               [listEditPathCallback]="getListEditPathCallback()"
               [specificColumnsTemplates]="[
                  {key: 'add-child-button', template: addChildButtonTemplate}
               ]">
</app-crud-list>
